<template>
	<div class="mb-4">
		<ClientsList></ClientsList>
	</div>
</template>

<script>
import ClientsList from '@/components/Widgets/Clients/ClientsList/ClientsList.vue';
export default {
  name: 'Products',
  components: {
    ClientsList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>